// location.service.ts
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

export interface LocationCoords {
  latitude: number;
  longitude: number;
  accuracy?: number;
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  getCurrentLocation(): Observable<LocationCoords> {
    return new Observable(observer => {
      if (!navigator.geolocation) {
        observer.error('Geolocation is not supported by this browser.');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords: LocationCoords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy
          };
          observer.next(coords);
          observer.complete();
        },
        (error) => {
          observer.error(this.getErrorMessage(error));
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
  }

  private getErrorMessage(error: any): string {
    switch (error.code) {
      case 1: return 'Permission denied';
      case 2: return 'Position unavailable';
      case 3: return 'Timeout';
      default: return 'Unknown error';
    }
  }
}